import { ONLINE_QUESTION_ANSWER_STATUS_END, ONLINE_QUESTION_ANSWER_STATUS_INPUT, } from '@/utils/constants/rfp/rfpOnlineQuestion/answerStatus';
/**
 * 質問 回答済か 判定
 */
export const isAnswered = (answerStatus) => answerStatus === ONLINE_QUESTION_ANSWER_STATUS_INPUT.value;
/**
 * 質問 募集終了か 判定
 */
export const isAnswerEnd = (answerStatus) => answerStatus === ONLINE_QUESTION_ANSWER_STATUS_END.value;
